import React from "react"
import { Link } from 'gatsby'

import "./Topbar.scss"

const Topbar = ({children}) => {
    return (
        <div className="Topbar">    
            <div className="LeftSide">
                <div className="topbar-title">
                    <ul className="Breadcrumb"><a href='/'>Homepage</a><li> / Application</li></ul>
                    <h3>Regional Economic Model for North Pacific Fisheries </h3>
                </div>
            </div>
            {children}
        </div>
    );
}

export default Topbar;